import { defineFieldAdapter, type FieldTransformers } from '@libs/shared/frontend/helpers/define-field-adapter.helper';

import { OrganizationUserRoleEnum, type components } from '@/libs/openapi';
import { formatEnumValue } from '@/utils/format.util';

export const fromApiOrganizationUserFieldAdapter = defineFieldAdapter({
  fields: {
    role: formatEnumValue(OrganizationUserRoleEnum),
  } satisfies FieldTransformers<components['schemas']['OrganizationUserResponseDto']>,
  meta: {},
}, 'strict');
